// extracted by mini-css-extract-plugin
export var cartouche = "cartouche-module--cartouche--sWJmc";
export var noPadding = "cartouche-module--noPadding--pNYmc";